export enum OrderLoadStatus {
    LOADING,
    LOADED_HAS_DATA,
    LOADED_HAS_NO_DATA,
}

export type OrderOwnerType = 'table' | 'table-group'
